<template>
  <ca-row>
    <ca-col>
      <ca-box-information :alert="recalculateMessage" />
    </ca-col>
  </ca-row>
</template>

<script>
import { RECALCULATE_BOX_INFORMATION } from '../constants/processingConstants';

export default {
  name: 'RecalculateBoxInformation',
  props: {
    shouldShowRecalculateMessage: Boolean,
  },
  data() {
    return {
      recalculateMessage: RECALCULATE_BOX_INFORMATION,
    };
  },
};
</script>
